import React, { RefObject } from 'react';
import SteamGameImportProgressCard from './SteamGameImportProgressCard';
import SteamGameImportStatusTable from './SteamGameImportStatusTable';
import SteamGameImportEfficiencyCard from './SteamGameImportEfficiencyCard';
import SteamGameImportLogPanel from './SteamGameImportLogPanel';
import type {
  FetchedGame,
  ImportedGame,
  LogEntry,
  StepRunState,
} from './steamGameImportTypes';

export interface SteamGameImportRunViewProps {
  isComplete: boolean;
  isImporting: boolean;
  progress: number;
  steps: StepRunState[];
  fetchedGames: FetchedGame[];
  importedGames: ImportedGame[];
  currentOperationLabel: string;
  stats: { games: number; skus: number; timeSaved: number };
  logs: LogEntry[];
  logContainerRef: RefObject<HTMLDivElement | null>;
  onClearLogs: () => void;
}

function SteamGameImportRunView({
  isComplete,
  isImporting,
  progress,
  steps,
  fetchedGames,
  importedGames,
  currentOperationLabel,
  stats,
  logs,
  logContainerRef,
  onClearLogs,
}: SteamGameImportRunViewProps) {
  return (
    <div
      className="row flex-grow-1 g-3 flex-nowrap mx-0"
      style={{ minHeight: 0 }}
    >
      <div
        className="col-lg-8 d-flex flex-column overflow-hidden"
        style={{ minHeight: 0 }}
      >
        <div className="d-flex flex-column flex-grow-1 overflow-hidden">
          <SteamGameImportProgressCard
            isComplete={isComplete}
            isImporting={isImporting}
            progress={progress}
            steps={steps}
            fetchedGamesCount={fetchedGames.length}
            currentOperationLabel={currentOperationLabel}
          />
          <SteamGameImportStatusTable
            importedGames={importedGames}
            fetchedGames={fetchedGames}
          />
        </div>
      </div>

      <div
        className="col-lg-4 d-flex flex-column overflow-hidden"
        style={{ minHeight: 0 }}
      >
        <div className="d-flex flex-column flex-grow-1 overflow-hidden">
          <SteamGameImportEfficiencyCard
            timeSavedMinutes={stats.timeSaved}
            gamesCount={stats.games}
            skusCount={stats.skus}
          />
          <SteamGameImportLogPanel
            ref={logContainerRef}
            logs={logs}
            onClear={onClearLogs}
          />
        </div>
      </div>
    </div>
  );
}

export default SteamGameImportRunView;
